import { CategoryPrescription } from "./CategoryPrescription"

export class ChainingDrugCatalog {
    constructor(
        public id: number,
        public description_french: string,
        public description_german: string,
    ) {}
}
